import { render, staticRenderFns } from "./EventRowMobile.vue?vue&type=template&id=899ed790&scoped=true&"
import script from "./EventRowMobile.vue?vue&type=script&lang=ts&"
export * from "./EventRowMobile.vue?vue&type=script&lang=ts&"
import style0 from "./EventRowMobile.vue?vue&type=style&index=0&id=899ed790&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899ed790",
  null
  
)

export default component.exports